<template>
    <!-- 商品详情图片/视频 -->
    <div class="product-info" id="product-info">

        <!-- 普通多媒体 -->
        <div v-if="!productData.is_rich">
            <p v-for="(item, index) in productData.content_iv">
                <img v-if="!mp4Reg.test(item)" v-lazy="item" alt="" src="" @load="loaded($event, index)">
                <video v-if="mp4Reg.test(item)" :src="item" muted loop controls playsinline="playsinline"
                       webkit-playsinline="webkit-playsinline"
                       poster="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAANSURBVBhXYzh8+PB/AAffA0nNPuCLAAAAAElFTkSuQmCC"></video>
            </p>
        </div>

        <!-- 富文本 -->
        <div v-if="productData.is_rich" v-html="productData.content"></div>

    </div>
</template>

<script>
  import config from "../../util/config";
  import {mallSubmit} from "../../api/permission";

  export default {
    props: {
      productData: {
        type: Object,
        default: {
          is_rich: '',
          content: [],
          content_iv: []
        }
      },
    },
    data() {
      return {
        mp4Reg: /.+\.mp4/,
        loading: config.loading,
      }
    },
    methods: {
      loaded(e, index) {
        // 如果不是初始图，说明用户已经访问到该图片
        if (e.target.src !== config.loading) {
          this.$emit('imgLoad', {index: index + 1, timeStamp: e.timeStamp});
        }
      }
    },
    mounted() {
      try {
        setTimeout(() => {
          const videoIo = new IntersectionObserver(
            function (entries) {
              entries.forEach(function (item) {
                if (item.intersectionRatio === 0) {
                  item.target.pause();
                } else {
                  item.target.play();
                }
              });
            }
          );
          const videoList = document.getElementById('product-info').getElementsByTagName('video');
          for (let i = 0; i < videoList.length; i++) {
            // 富文本视频添加属性 视频元素先操作一次保证自动播放
            videoList[i].muted = 'muted';
            videoList[i].loop = 'loop';
            videoList[i].controls = '';
            videoList[i].setAttribute('playsinline', 'playsinline');
            videoList[i].setAttribute('webkit-playsinline', 'webkit-playsinline');
            videoIo.observe(videoList[i]);
          }
        }, 100);
      } catch (e) {
        // 保证富文本视频按要求显示
        setTimeout(() => {
          const videoList = document.getElementById('product-info').getElementsByTagName('video');
          for (let i = 0; i < videoList.length; i++) {
            // 富文本视频添加属性 视频元素先操作一次保证自动播放
            videoList[i].muted = 'muted';
            videoList[i].loop = 'loop';
            videoList[i].controls = 'controls';
            videoList[i].setAttribute('playsinline', 'playsinline');
            videoList[i].setAttribute('webkit-playsinline', 'webkit-playsinline');
          }
        }, 100);
      }
    }
  }
</script>

<style>
    .product-info {
        border-top: 1px solid #eee;
        width: 100%;
        overflow: hidden;
    }

    .product-info img,
    .product-info video {
        width: 100% !important;
        height: auto !important;
        vertical-align: bottom;
    }
</style>



// WEBPACK FOOTER //
// src/components/detail/product-info.vue